const qs = require('qs')
const { showError, showNotifikasi } = require('../../libs/helper')

module.exports = {
  getData: (g, params) => g.$http({
    url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/cleansing/list`,
    method: 'post',
    params,
  })
    .then(res => {
      try {
        if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) {
          showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)
        }

        return res.data
      } catch (error) {
        console.log(error)
        return {}
      }
    })
    .catch(err => {
      showError(g, err, 'Error Submit Form')
    }),
  submit: (g, data) => {
    g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/cleansing/store`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) {
            throw Error({ response: { data: res.data.message } })
          }

          g.$router.push({ name: 'koreksiCleansing' })
        } catch (error) {
          console.log(error)
        }
      })
      .catch(err => {
        showError(g, err, 'Error Submit Form')
      })
  },
  getDataById: (g, id) => g.$http({
    url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/cleansing/show`,
    method: 'post',
    params: {
      id,
      username: g.$cookies.get('username'),
    },
  })
    .then(res => {
      try {
        if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) {
          showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)
        }

        return res.data
      } catch (error) {
        console.log(error)
        return {}
      }
    })
    .catch(err => {
      showError(g, err, 'Error Submit Form')
    }),
}
